import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { ITV_TYPES } from "@/lib/interventions";
import { PRIORITIES } from "@/components/activities/ActivityDialog";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const hours = (m) => (m == null ? "" : String(Math.round((m / 60) * 10) / 10));

const PolicyRow = ({ p, editable }) => {
  const [f, setF] = useState({ r: hours(p.response_min), s: hours(p.resolution_min) });
  const dirty = f.r !== hours(p.response_min) || f.s !== hours(p.resolution_min);
  const save = async () => {
    try {
      await api.put(`/sla-policies/${p.id}`, { response_min: Math.round(Number(f.r) * 60), resolution_min: f.s === "" ? null : Math.round(Number(f.s) * 60) });
      p.response_min = Math.round(Number(f.r) * 60); p.resolution_min = f.s === "" ? null : Math.round(Number(f.s) * 60);
      setF({ ...f }); toast.success("Regola SLA aggiornata");
    } catch (e) { toast.error(errorMessage(e)); }
  };
  return (
    <tr className="border-b border-line/60" data-testid={`sla-policy-${p.type}-${p.priority}`}>
      <td className="py-1.5 pr-2 text-xs text-slate-600">{PRIORITIES.find((x) => x.key === p.priority)?.label}</td>
      <td className="py-1.5 pr-2"><Input type="number" min="0.1" step="0.5" value={f.r} disabled={!editable} onChange={(e) => setF({ ...f, r: e.target.value })} className="h-8 w-20" data-testid={`sla-resp-${p.type}-${p.priority}`} /></td>
      <td className="py-1.5 pr-2"><Input type="number" min="0.1" step="0.5" value={f.s} disabled={!editable} placeholder="—" onChange={(e) => setF({ ...f, s: e.target.value })} className="h-8 w-20" data-testid={`sla-res-${p.type}-${p.priority}`} /></td>
      <td className="py-1.5">{editable && dirty && <Button size="sm" onClick={save} disabled={!(Number(f.r) > 0)} data-testid={`sla-save-${p.type}-${p.priority}`}>Salva</Button>}</td>
    </tr>
  );
};

export const SlaPoliciesDialog = ({ open, onOpenChange, editable }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { if (open) api.get("/sla-policies").then((r) => setItems(r.data.items)).catch((e) => toast.error(errorMessage(e))); }, [open]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-lg" data-testid="sla-policies-dialog">
        <DialogHeader>
          <DialogTitle>Regole SLA (ore, 24/7)</DialogTitle>
          <DialogDescription>Tempi di presa in carico e risoluzione per tipologia e priorità. Valori generici iniziali, da adattare. Si applicano ai nuovi interventi.</DialogDescription>
        </DialogHeader>
        {ITV_TYPES.map((t) => (
          <section key={t.key} className="mb-2">
            <p className="mb-1 text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">{t.label}</p>
            <table className="w-full">
              <thead><tr className="text-left text-[11px] text-slate-400"><th className="font-medium">Priorità</th><th className="font-medium">Presa in carico</th><th className="font-medium">Risoluzione</th><th /></tr></thead>
              <tbody>{items.filter((p) => p.type === t.key).sort((a, b) => PRIORITIES.findIndex((x) => x.key === b.priority) - PRIORITIES.findIndex((x) => x.key === a.priority))
                .map((p) => <PolicyRow key={p.id} p={p} editable={editable} />)}</tbody>
            </table>
          </section>
        ))}
      </DialogContent>
    </Dialog>
  );
};
